export const SET_STONE_CONFIGURATED = 'STONE/SET_STONE_CONFIGURATED';
